import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { NavMarker } from 'react-rhumb';
import { AnimatedStepBody } from '../animation/StepBodyAnimations';
import { useIsFramedCentredStep } from '../hooks/useIsFramedCentredStep';
import { CompanySizeSelect } from './CompanySizeSelect';
import { useLandingPage } from '../step-landing-page/useLandingPage';
import { Step } from '../views/Step';
import NextButtonWrapper from '../views-components/NextButtonWrapper';
import { Data } from '../signup-data/DATA';
import { SignupDataInput } from '../signup-data/SignupDataInput';
import { LandingPageTitleWrapper, StyledH1 } from '../step-landing-page/LandingPageView';
import { useView } from '../views/useView';
import { getFlowKey } from '../routing/getFlowKey';
import { HubletOnePage } from './HubletOnePage';
import { IndustrySelect } from './IndustrySelect';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';

const OnePageSignupView = () => {
  const stepKey = Step.OnePageSignupGoogle;
  const flowKey = getFlowKey();
  const {
    chooseEmailSignUp
  } = useLandingPage(stepKey);
  const {
    isFramedCentredStep
  } = useIsFramedCentredStep();
  const {
    submit
  } = useView({
    stepKey
  });
  const {
    isMobile
  } = useResponsiveness();

  const renderContent = () => /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("form", {
      action: "blue-button-in-all-fields-ios",
      onSubmit: chooseEmailSignUp,
      children: [/*#__PURE__*/_jsx(SignupDataInput, {
        dataKey: Data.CompanyName
      }), /*#__PURE__*/_jsx(IndustrySelect, {}), /*#__PURE__*/_jsx(CompanySizeSelect, {}), /*#__PURE__*/_jsx(SignupDataInput, {
        dataKey: Data.CompanyDomain
      }), /*#__PURE__*/_jsx(HubletOnePage, {}), /*#__PURE__*/_jsx(NextButtonWrapper, {
        className: isFramedCentredStep ? '' : 'm-top-3',
        onClick: submit
      })]
    })
  });

  const renderTitle = () => {
    const title = `views.${stepKey}.title.default`;
    return /*#__PURE__*/_jsx(LandingPageTitleWrapper, {
      className: `text-center m-x-auto flex-column justify-center`,
      shouldSetMaxWidth: !isValidI18nKey(title),
      children: /*#__PURE__*/_jsx(StyledH1, {
        flowKey: flowKey,
        isFramedCentredStep: isFramedCentredStep,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: title
        })
      })
    });
  };

  return /*#__PURE__*/_jsx(NavMarker, {
    name: Step.OnePageSignupGoogle,
    children: /*#__PURE__*/_jsx(AnimatedStepBody, {
      animationDelay: true,
      disableAnimation: isMobile,
      children: /*#__PURE__*/_jsxs("div", {
        "data-selenium": `${stepKey}_VIEW`,
        children: [renderTitle(), renderContent()]
      })
    })
  });
};

export default OnePageSignupView;